import {SimpleIconButton} from "../../../misc/lists/SimpleIconButton";
import {useState} from "react";
import {Popover} from "../../../misc/Popover";
import {css} from "@emotion/css";
import {grey} from "@mui/material/colors";
import {useGetAll} from "./useGetAll";
import {api} from "../../../api/API";
import moment from "moment";
import HistoryIcon from '@mui/icons-material/History';

export function AuditLogIconPopper(props: {
    group: number;
}) {
    const [preview, setPreview] = useState<HTMLElement|null>(null);

    return (
        <>
            <SimpleIconButton
                onMouseEnter={(e: any) => {
                    setPreview(e.target as any);
                }}
                onMouseLeave={() => setPreview(null)}
            >
                <HistoryIcon/>
            </SimpleIconButton>

            {preview && <AuditItems group={props.group} onClose={() => setPreview(null)} anchorEl={preview}/>}
        </>
    )
}

export function AuditItems(props: {
    group: number;
    anchorEl: any;
    onClose(): void;
}) {
    const items = useGetAll(input => api.logistics.listRouteAudit(input), {
        group: props.group,
    }, [props.group], {
        useLazy: true,
    })

    return (
        <Popover open={true}
                 anchorEl={props.anchorEl}
                 sx={{
                     pointerEvents: 'none',
                 }}
                 disableRestoreFocus
                 onClose={props.onClose}
                 anchorOrigin={{
                     vertical: 'top',
                     horizontal: 'left',
                 }}
                 transformOrigin={{
                     vertical: 'bottom',
                     horizontal: 'left',
                 }}
        >
            {items.LoadingOrErrorElement}
            <div style={{padding: 4}}>
                <table className={tableClass}>
                    <thead>
                    <tr>
                        <td>Item</td>
                    </tr>
                    </thead>
                    <tbody>
                    {items.asList.map(c => <tr>
                        <td>
                            <div>{c.description}</div>
                            <div>{moment(c.updatedAt).format("MMM-D, YYYY h:mm a")}</div>
                            <div>{c.updatedByName}</div>
                        </td>
                    </tr>)}
                    {items.asList.length === 0 && <tr>
                        <td>
                            No audit log entries
                        </td>
                    </tr>}
                    </tbody>
                </table>
            </div>
        </Popover>
    )
}

// @ts-ignore
const tableClass = css({
    fontSize: "0.8rem",
    cellSpacing: 0,
    borderCollapse: "collapse",

    "& > thead": {
        fontWeight: "bold",

        "& td": {
            borderBottom: "1px solid " + grey["400"],
        }
    },

    "& > tbody > tr:not(:last-child) > td": {
        borderBottom: "1px solid " + grey["200"]
    },

    "& > * > tr > td": {
        paddingLeft: 2, paddingRight: 4,
    }
})